// Module
var code = `<div class="js-screen-brokerinfo">
    <terceraPictureBox imageUrl="{{.imageUrl}}" component_style="js-brand-image" />
    <div class="js-broker-info-text"></div>
</div>`;
// Exports
export default code;